import type { OnboardingThemeSettingsV2 } from '@modules/firebase-core/converters/onboardingConverter';
import { defaultThemeV2Mapper } from '@modules/themes/mappers/DefaultThemeV2Mapper';
import type { ThemeV2 } from '@modules/themes/types/themesV2.types';
import { onboardingThemeToSystemTheme, type SystemThemeBody } from './onboardingThemeCopy';

/**
 * Admin → Themes V2 → Import Theme JSON (an onboarding's Export V2 Theme JSON — the DEV → PROD path, owner
 * decision 4A of the onboarding theme switch plan). The new system theme is the FULL theme
 * (`onboardingThemeToSystemTheme`: animation scheme, web view colour, layout, generated metadata included), and an
 * exported file's screen templates are kept as authored. Only a file without templates gets the default ones,
 * styled with the imported tokens.
 */
export function importedThemeSettingsToSystemTheme(
  imported: OnboardingThemeSettingsV2,
  name: string,
): SystemThemeBody {
  const body = onboardingThemeToSystemTheme(imported as unknown as Record<string, unknown>, { name });
  const flowDocument = imported.flowDocument
    ? body.flowDocument
    : defaultThemeV2Mapper.applyToFlowDocument(body as unknown as ThemeV2, body.flowDocument);
  // JSON round-trip strips undefined values (Firestore rejects undefined).
  return JSON.parse(JSON.stringify({ ...body, flowDocument })) as SystemThemeBody;
}
